"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgAvatar = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _AvatarContainer = require("./AvatarContainer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AvatarSvg = _styledComponents["default"].div.withConfig({
  displayName: "SvgAvatar__AvatarSvg",
  componentId: "vmqmm3-0"
})(["width:24px;height:24px;margin-right:5px;"]);

var SvgAvatar = function SvgAvatar(props) {
  return /*#__PURE__*/_react["default"].createElement(_AvatarContainer.AvatarContainer, null, /*#__PURE__*/_react["default"].createElement(AvatarSvg, null, props.svg), " ", props.name);
};

exports.SvgAvatar = SvgAvatar;
SvgAvatar.propTypes = {
  svg: _propTypes["default"].element,
  name: _propTypes["default"].string
};